<template>
  <div class="ola-logo" :style="{ height: height + 'px', width: width + 'px' }">
    <router-link :to="'/'" class="ola-logo-link">
      <img :src="logoSrc" :alt="alt" class="ola-logo-img" @error="handleImageError" />
    </router-link>
  </div>
</template>

<script>
import { getImagePath, getRootImagePath } from '@/utils/ImageHelper'

export default {
  name: 'OlaLogo',
  props: {
    // Logo图片地址
    src: {
      type: String,
      default: ''
    },
    // 图片替代文本
    alt: {
      type: String,
      default: 'Logo'
    },
    // 内部路由链接
    to: {
      type: [String, Object],
      default: null
    },
    // 外部链接
    href: {
      type: String,
      default: null
    },
    // Logo高度
    height: {
      type: [Number, String],
      default: 40
    },
    // Logo宽度
    width: {
      type: [Number, String],
      default: 139
    },
    // 是否使用当前语言目录下的logo
    useLocaleLogo: {
      type: Boolean,
      default: false
    },
    // 自定义logo文件名
    filename: {
      type: String,
      default: 'logo.png'
    },
    // 默认语言，当环境变量不可用时使用
    defaultLocale: {
      type: String,
      default: 'fr'
    }
  },
  data() {
    return {
      // 标记图片是否加载失败
      isImageFailed: false,
      // 备选路径
      fallbackPath: ''
    };
  },
  computed: {
    // 获取当前语言
    currentLocale() {
      try {
        // 尝试获取环境变量
        if (typeof __SITE_PROFILE__ !== 'undefined') {
          return `${__SITE_PROFILE__}` || this.defaultLocale;
        }
      } catch (e) {
        // 静默处理，使用默认语言
      }
      return this.defaultLocale;
    },
    
    // 简化的logo路径逻辑
    logoSrc() {
      // 如果图片加载失败且已设置备选路径，则使用备选路径
      if (this.isImageFailed && this.fallbackPath) {
        return this.fallbackPath;
      }
      
      // 1. 如果提供了src，直接使用
      if (this.src) {
        return this.src;
      }
      
      // 2. 如果需要使用本地化logo
      if (this.useLocaleLogo) {
        // 使用imageHelper处理语言特定的图片路径
        return getImagePath(this.filename, this.currentLocale);
      }
      
      // 3. 默认使用根目录下的logo
      return getRootImagePath(this.filename);
    }
  },
  methods: {
    // 简化的图片加载失败处理
    handleImageError(event) {
      // 标记图片加载失败
      this.isImageFailed = true;
      
      // 根据情况设置备选路径
      if (this.useLocaleLogo) {
        // 如果使用了语言特定的logo，尝试使用默认logo
        this.fallbackPath = getRootImagePath(this.filename);
      } else {
        // 如果是其他情况，使用内置的默认图片
        event.target.src = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCAxMDAgNDAiPjxyZWN0IHdpZHRoPSIxMDAiIGhlaWdodD0iNDAiIGZpbGw9IiNmMWYxZjEiLz48dGV4dCB4PSI1MCIgeT0iMjAiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxNiIgZmlsbD0iIzU1NSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZG9taW5hbnQtYmFzZWxpbmU9Im1pZGRsZSI+TG9nbzwvdGV4dD48L3N2Zz4=';
      }
    }
  }
};
</script>

<style>
.ola-logo {
  display: inline-block;
  height: 40px;
  width: 139px;
  position: relative;
  overflow: hidden;
}

.ola-logo-link {
  display: inline-block;
  height: 100%;
  width: 100%;
  text-decoration: none;
}

.ola-logo-img {
  height: 100%;
  width: 100%;
  vertical-align: middle;
  object-fit: contain;
  transition: transform 0.3s;
}
</style> 